import React, { useEffect, useState, useRef, useCallback } from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';

import { observer } from 'mobx-react-lite';
import Model from '../../../model';
import { OtvetAudioPlayer } from 'components/Audio';
import Page from '../../pages/Page';
import './index.sass';
import Text from 'components/Text';

const { cnBlock, el } = bem( 'audiobook-page' )

const book = [
    {
        url: '/media/books/10 писем к тебе/1.mp3',
        name: 'Письмо 1 Научись ошибаться',
        duration: 253.204898
    },
    {
        url: '/media/books/10 писем к тебе/2.mp3',
        name: 'Письмо 2 Постарайся не спутать свои чувства',
        duration: 176.065306
    },
    {
        url: '/media/books/10 писем к тебе/3.mp3',
        name: 'Письмо 3 Создавай с душой',
        duration: 188.029388
    },
    {
        url: '/media/books/10 писем к тебе/4.mp3',
        name: 'Письмо 4 Помни, что ребенок - после мамы и папы',
        duration: 591.777959
    },
    {
        url: '/media/books/10 писем к тебе/5.mp3',
        name: 'Письмо 5 Окружи себя красотой',
        duration: 287.634286
    },
    {
        url: '/media/books/10 писем к тебе/6.mp3',
        name: 'Письмо 6 Стань привлекательной для самой себя',
        duration: 323.108571
    },
    {
        url: '/media/books/10 писем к тебе/7.mp3',
        name: 'Письмо 7 Не стремись к отношениям любой ценой',
        duration: 312.032653
    },
    {
        url: '/media/books/10 писем к тебе/8.mp3',
        name: 'Письмо 8 Научись слышать себя',
        duration: 378.253061
    },
    {
        url: '/media/books/10 писем к тебе/9.mp3',
        name: 'Письмо 9 Не забывай о саморазвитии',
        duration: 539.689796
    },
    {
        url: '/media/books/10 писем к тебе/10.mp3',
        name: 'Письмо 10 Оставайся собой',
        duration: 376.032653
    },
    {
        url: '/media/books/10 писем к тебе/11.mp3',
        name: 'Письмо в будущее',
        duration: 63.268571
    }
]

const itemName = 'Аудиокнига «10 писем к тебе»';

const Audiobook = () => {
    const { user } = Model;

    const [ bookDuration, setBookDuration ] = useState(book.map(chapter => chapter.duration));
    const [ activeChapter, setActiveChapter ] = useState( 0 );
    const [ isPlaying, setIsPlaying ] = useState( false );
    const [ loading, setLoading ] = useState(false);
    const [ showPlayer, setShowPlayer ] = useState( false );

    const [ item, setItem ] = useState( null );

    useEffect(() => {
        setLoading(true);
        user.getDigital(itemName)
            .then((digital) => {
                setLoading(false);
                if (digital !== undefined) {
                    setItem(digital);
                }
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
            });
    }, []);

    const player = useRef( null );

    if (loading) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={itemName} loading={loading} />
    }

    if ( !item ) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={itemName} >
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не был приобретен для пользователя ${user.username}`}</Text>
                </div>
            </div>
        </Page>
    }

    const files = item?.digital?.files.filter(file => !!file.isActive);

    if (files.length === 0) {
        return <Page className={ cnBlock( 'supervision-course-page' ) } title={itemName} >
            <div className={ el( 'content' ) }>
                <div className={ el('info') }>
                    <Text>{`Курс не содержит материалов`}</Text>
                </div>
            </div>
        </Page>;
    }

    const nextChapterClick = () => {
        if ( activeChapter < ( book.length - 1 ) ) {
            setActiveChapter( ( oldChapter ) => oldChapter + 1 )
        }
    }
    const prevChapterClick = () => {
        if ( activeChapter > 0 ) {
            setActiveChapter( ( oldChapter ) => oldChapter - 1 )
        }
    }
    const onChapterClick = ( e ) => ( index ) => {
        if ( index === activeChapter ) {
            player?.current?.togglePlay( e )
        } else {
            setActiveChapter( index );
        }
    }

    const prettifyDuration = (ms) => {
        const minutes = Math.floor( ms / 60 ).toString().padStart(2, '0');
        const seconds = Math.floor( ms % 60 ).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    }

    const Chapter = ({index, title}) => {
        const handleClick = useCallback((e) => {
            onChapterClick(e)(index);
        }, []);
        const duration = bookDuration[index] ? prettifyDuration(bookDuration[index]) : `--:--`;
        return (
            <div className={el('chapter')} onClick={handleClick}>
                <Text>{ title }</Text>
                <div className={el('chapter-icon')}>
                    <Icon name={ activeChapter === index && isPlaying ? 'pause' : 'play' }/>
                </div>
                {/*<div className={el('chapter-duration')}>*/}
                {/*    <Text>{duration}</Text>*/}
                {/*</div>*/}
            </div>
        )
    }

    return <Page className={ cnBlock( 'supervision-course-page' ) } title={itemName} >
        <div className={ el( 'book' ) }>
            <div className={ el( 'book-cover' ) }/>
            <div className={ el( 'chapters-list' ) }>
                { files.map( ( chapter, index ) =>
                    <Chapter key={index} index={index} title={files[index].title} />
                ) }
            </div>
        </div>
        <div className={ el( 'player', {'hidden': !showPlayer} ) }>
            <OtvetAudioPlayer
                src={ `/media/${ files?.[activeChapter]?.file }` }
                onPlay={ () => {
                    setIsPlaying(true);
                    setShowPlayer(true)
                }}
                onPause={ () => {
                    setIsPlaying(false);
                }}
                onClickPrevious={ prevChapterClick }
                onClickNext={ nextChapterClick }
                ref={player}
            />
        </div>
    </Page>
}

export default observer(Audiobook);
